import React, { useEffect } from 'react';
import * as ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import c from 'classnames';
import { UserState } from '../../ducks';
import { ClickElement } from '../form';
import { LoginForm } from './';
import { Title } from '../title';
import styles from './LoginPage.css';
import { useAuthCheck } from './hooks';
import { LOGINPAGE } from '../../lib/labels';
import { settings } from '../../settings';

const prevLocation = (historyState, hasPrevLocation) => {
  if (hasPrevLocation) {
    const { prevLocation } = historyState;
    if(typeof prevLocation === 'object') {
      const hasSearchProperty = Object.prototype.hasOwnProperty.call(prevLocation, 'search');
      return hasSearchProperty ? prevLocation.pathname + prevLocation.search : prevLocation.pathname;
    } else {
      return prevLocation;
    }
  }
  return '/';
};

export const LoginPage = ({ history }) => {

  const [userState, isLoggedIn] = useAuthCheck();
  const isLoading = userState === UserState.PENDING;
  const { location: { pathname: historyPathname, state: historyState } } = history;
  const hasPrevLocation = historyState && historyState.prevLocation;
  const isRedirected = hasPrevLocation && (
    historyPathname.replace('/', '') === 'nslogin' || 
    prevLocation(historyState, hasPrevLocation).replace('/', '') === 'stem'
  ); 

  useEffect(() => {
    if (UserState.CHECKED === userState && isLoggedIn) {
      ReactGA.event({
        category: 'User',
        action: 'Logs in',
        label: prevLocation(historyState, hasPrevLocation),
      });
      history.replace(prevLocation(historyState, hasPrevLocation));      
    }
  }, [userState, isLoggedIn]);

  return(
    <div className={c(['container-spacious'], styles.loginform)}>
      <ClickElement
        tertiary
        ElementType={Link}
        type="button"
        text={<>Sluiten<FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: '5px'}}/></>}
        to={isRedirected ? '/' : prevLocation(historyState, hasPrevLocation)}
        style={{ marginBottom: '20px'}}
      />      
      {historyState && historyState.nsfwItem && (
        <div className={styles.section_message}>
          <Title Tag='h1'>
              Dit is een NSFW item
          </Title>
          <div className="indent">
            <p>
                Om dit item te kunnen bekijken moet je ingelogd zijn.
            </p>
          </div>
        </div>
      )}
      <section>
        <Title Tag='h2'>
          {LOGINPAGE.LOGIN_BLOCK.TITLE}
        </Title>
        <div className="indent">
          <p>
            {LOGINPAGE.LOGIN_BLOCK.TEXT}
          </p>
        </div>
        <LoginForm isLoading={isLoading} isLoggedIn={isLoggedIn}/>
      </section>
      <section>
        <Title Tag='h2'>
          {LOGINPAGE.REGISTER_BLOCK.TITLE}
        </Title>
        <div className="indent">
          <p>
            {LOGINPAGE.REGISTER_BLOCK.TEXT}
          </p>
        </div>
        <ClickElement
          tertiary
          ElementType="a"
          type="button"
          text={LOGINPAGE.REGISTER_BLOCK.BUTTON}
          href={`${settings.USER_HOST}/user/register`}
          rel="noopener noreferrer"
          target="_blank"
        />
      </section>
    </div>
  );
};
